import React, { Component } from 'react'
import styled from 'styled-components'
import GameService from '../../services/game'
import PuzzleTable from './puzzleTable'
import Upload from '../upload/upload'
import Loading from '../loading'
import Modal from '../modal'
import './newGame.scss'

const StyledModal = styled(Modal)`
  width: 100%;
`
const StyledTable = styled(PuzzleTable)`
  width: 90%;
  margin: 0 auto;
`
const TableBox = styled.div`
  height: 420px;
  overflow: auto;
`
const PageButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 50%;
  margin: 20px auto 0;
  text-align: center;
  align-items: center;
  
  > div {
    flex: 1;
    font-size: 1.4em;
    color: #333;
  }

  > div.page-btn {
    font-size: 2em;
    cursor: pointer;

    &[disabled] {
      visibility: hidden;
      cursor: initial;
    }
  }
`
const MissingText = styled.p`
  display: flex;
  margin: 0;
  height: 100%;
  align-items: center;
  justify-self: center;
`

export class NewGame extends Component {
  constructor (props) {
    super(props)

    this.state = { files: [], page: 1, loading: true }
    this.loadFiles()
  }

  loadFiles = () => {
    const { page } = this.state
    const userToken = localStorage.getItem('userToken')
    GameService.getPuzzles(page, userToken)
      .then(files => {
        this.setState({ files })
      })
      .finally(() => {
        this.setState({ loading: false })
      })
  }

  handleNextPage = () => {
    this.setState(
      prevState => ({ page: prevState.page + 1, loading: true }),
      this.loadFiles,
    )
  }

  handlePreviousPage = () => {
    this.setState(
      prevState => ({ page: Math.max(prevState.page - 1, 0), loading: true }),
      this.loadFiles,
    )
  }

  onStart = (filename) => {
    const { history } = this.props
    GameService.createGame(filename)
      .then(game => {
        history.push(`/game/${game.short_id}`)
      })
  }

  render() {
    const { files, page, loading } = this.state
    return (
      <StyledModal
        title='Start new game'>
        <div className='NewGame'>
          <TableBox>
            {loading && <Loading />}
            {!loading && files && files.length > 0 && (
              <StyledTable
                files={files}
                onStart={this.onStart} />
            )}
            {!loading && !files?.length && (
              <MissingText>Unable to load puzzles :(</MissingText>
            )}
          </TableBox>
          {files?.length > 0 && (
            <PageButtons>
              <div className='page-btn' onClick={this.handlePreviousPage} disabled={page === 1}>&lt;</div>
              <div>{page}</div>
              <div className='page-btn' onClick={this.handleNextPage} disabled={files.length < 10}>&gt;</div>
            </PageButtons>
          )}
          <Upload />
        </div>
      </StyledModal>

    )
  }
}

export default NewGame
